import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {

    BACK_UPSELLING_CREAR: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.upselling.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    BACK_UPSELLING_EDITAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.upselling.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    BACK_UPSELLING_INDEX: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.upselling.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    BACK_UPSELLING_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.upselling.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    BACK_UPSELLING_DETALLES_ECONOMICOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.upselling.detalles-economicos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    BACK_UPSELLING_ELIMINAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.upselling.eliminar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
}

export default {
    actions
};